import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import classNames from "classnames";
import Popup from "reactjs-popup";

import isVisible from "../../common-functions/isVisible"
import getPrivileges from "../../common-functions/getPrivileges"
import Subscriptions from "../AdminDashboard/Subscriptions";
import AddMember from "../AdminDashboard/AddMember";
import { getUser } from "../../actions/memberActions";
import { showMemberPopup, hideMemberPopup } from "../../actions/popupActions";
import { deleteStripeOrder } from "../../actions/oneShoppingCartActions";
const { getLatestSyncOrderIdSet, getOrderLocalId } = require("./orderHighlightHelpers");

class OrderList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCourseModalOpen: false,
      selectedOrder: null,
      isDetailModalOpen: false,
      selectedOrderDetail: null
    };

    this.openCourseModal = this.openCourseModal.bind(this);
    this.closeCourseModal = this.closeCourseModal.bind(this);
    this.openDetailModal = this.openDetailModal.bind(this);
    this.closeDetailModal = this.closeDetailModal.bind(this);
  }

  openCourseModal(order) {
    this.setState({ isCourseModalOpen: true, selectedOrder: order });
    this.props.getUser(order.UserId);
  }

  closeCourseModal() {
    this.setState({ isCourseModalOpen: false });
  }

  openDetailModal(order) {
    this.setState({ isDetailModalOpen: true, selectedOrderDetail: order });
  }

  closeDetailModal() {
    this.setState({ isDetailModalOpen: false });
  }

  handleDeleteOrder(order) {
    const page = this.props.page || 1;
    this.props.deleteStripeOrder(order.Id || order.id, page)
      .then(() => {
        this.closeDetailModal();
      })
      .catch(() => {});
  }

  getProductTypeLabel(purchaseType) {
    switch (purchaseType) {
      case "course":
        return "Course";
      case "subscription":
        return "Subscription";
      case "pas":
        return "Planning and Scanning (PAS)";
      default:
        return "Not identified";
    }
  }

  normalizeOrder(order) {
    const metadata =
      (order.rawSession && order.rawSession.metadata) || order.metadata || {};
    const amountTotal =
      order.amountTotal !== undefined && order.amountTotal !== null
        ? (order.amountTotal / 100).toFixed(2)
        : "";
    const source = order.source || (order.stripeSessionId ? "Stripe" : "");

    return {
      source,
      Id: order.Id || order.id || order.stripeSessionId || order.orderId || "-",
      Email: order.Email || order.email || "-",
      OrderDescription: order.OrderDescription || order.description || "-",
      purchaseType: order.purchaseType || order.PurchaseType,
      stripePriceId: order.stripePriceId || order.StripePriceId || "-",
      CustomerName:
        order.CustomerName ||
        order.customerName ||
        order.email ||
        "No Data Available",
      UserId: order.UserId || order.userId || null,
      userMatch: order.userMatch !== undefined ? order.userMatch : Boolean(order.UserId || order.userId),
      productMatch: order.productMatch !== undefined ? order.productMatch : true,
      OrderedAt: order.OrderedAt || order.orderedAt || order.createdAt,
      ProductName:
        order.ProductName ||
        order.productName ||
        metadata.displayName ||
        order.purchaseType ||
        "No Data Available",
      GrandTotal:
        order.GrandTotal !== undefined
          ? order.GrandTotal
          : amountTotal
            ? amountTotal
          : order.total !== undefined && order.total !== null
            ? order.source === "stripe" || order.source === "Stripe"
              ? (order.total / 100).toFixed(2)
              : order.total
            : "",
      OrderChargeStatusType:
        order.OrderChargeStatusType ||
        (order.paymentStatus === "paid" ? "Accepted" : order.paymentStatus) ||
        "No Data Available",
      completed: order.completed,
      fulfillmentStatus: order.fulfillmentStatus,
      fulfillmentError: order.fulfillmentError,
      transactionReason: order.transactionReason || order.reason || "",
      manualReviewReason: order.manualReviewReason || "",
      completionDate: order.completionDate || order.fulfilledAt,
      ClientId: order.ClientId || order.clientId
    };
  }

  getOrderReason(order) {
    if (order.transactionReason) {
      return order.transactionReason;
    }

    if (order.OrderChargeStatusType === "Manual Review") {
      return order.manualReviewReason || order.fulfillmentError || "";
    }

    return "";
  }

  renderAmount(order) {
    if (!order.GrandTotal) {
      return "-";
    }

    return "$" + order.GrandTotal;
  }

  renderDetailButton(order, label = "View Details", className = "btn btn-link p-0") {
    return (
      <button
        type="button"
        className={className}
        onClick={() => this.openDetailModal(order)}
      >
        {label}
      </button>
    );
  }

  render() {
    const {
			auth
		} = this.props
		const privileges = getPrivileges(auth);
    const isShow = privileges && isVisible(privileges, "order")
    const isEditable = privileges && isVisible(privileges, "members", "edit")
    if(!isShow){
      return <div className="p-5"></div>
    }
    const latestSyncOrderIds = getLatestSyncOrderIdSet(this.props.latestSyncOrderIds);
    const orders = this.props.orders.map((rawOrder, index) => {
      const order = this.normalizeOrder(rawOrder);
      const isNewlySynced = latestSyncOrderIds.has(getOrderLocalId(order));
      const rowKey = `${order.source || "unknown"}-${order.Id || "unknown"}-${index}`;
      let dateCompleted = null;
      if (order.completionDate) {
        dateCompleted = moment(order.completionDate).format("MM-DD-YYYY");
      }
      const orderReason = this.getOrderReason(order);
      return (
        <li
          key={rowKey}
          className={classNames("list-group-item list-group-item-action", {
            "border-left border-info": isNewlySynced,
          })}
          style={isNewlySynced ? { backgroundColor: "#f4fbff", borderLeftWidth: "4px" } : undefined}
        >
          <div className="row">
            {isEditable && <div className="col-2 text-left">
              {order.source ? (
                this.renderDetailButton(order, order.source || "Order Source", "btn btn-link p-0")
              ) : (
                <span>{order.source}</span>
              )}
            </div>}
            <div className={classNames("text-left ", {
              "col-2": isEditable,
              "col-3": !isEditable,
            })}>
              {isEditable && order.UserId ? (
                <div>
                  <span
                    className="btn-link"
                    style={{ cursor: "pointer" }}
                    onClick={() => this.openCourseModal(order)}
                    title="Manage courses for this customer"
                  >
                    {order.CustomerName}
                  </span>
                  {isNewlySynced && (
                    <span className="badge badge-info ml-2">NEW</span>
                  )}
                </div>
              ) : (
                <div>
                  <div>
                    {order.CustomerName}
                    {isNewlySynced && (
                      <span className="badge badge-info ml-2">NEW</span>
                    )}
                  </div>
                  {isEditable && !order.UserId && order.source === "Stripe" && (
                    <div className="mt-1">
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        onClick={() => {
                          this.closeDetailModal();
                          this.props.showMemberPopup();
                        }}
                      >
                        Add Member
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="col-3 text-right">
              {order.OrderedAt
                ? moment(order.OrderedAt).format("dddd, MMMM Do YYYY")
                : "-"}
            </div>
            <div className="col-3 text-right">
              {order.productMatch ? (
                order.ProductName
              ) : (
                <span className="text-warning">No product match</span>
              )}
            </div>
            <div className="col-2 text-right">
              <strong>{this.renderAmount(order)}</strong>
              <br />
              {order.OrderChargeStatusType === "Accepted" ||
              order.OrderChargeStatusType === "Completed marker" ? (
                <span className="text-success">
                  {order.OrderChargeStatusType}
                </span>
              ) : (
                <span className="text-danger">
                  {order.OrderChargeStatusType}
                </span>
              )}
              <br />

              {orderReason ? (
                <React.Fragment>
                  <span className="text-muted">{orderReason}</span>
                  <br />
                </React.Fragment>
              ) : order.fulfillmentStatus === "user_not_found" ? (
                <React.Fragment>
                  <span className="text-danger">User not found</span>
                  <br />
                </React.Fragment>
              ) : order.OrderChargeStatusType === "Manual Review" && order.fulfillmentError ? (
                <React.Fragment>
                  <span className="text-danger">{order.fulfillmentError}</span>
                  <br />
                </React.Fragment>
              ) : null}

              <div>
                {order.completed === true ? (
                  <i className="fas fa-check-double" />
                ) : (
                  <i className="fas fa-times-circle" />
                )}
              </div>
              <div>{dateCompleted}</div>
              <div className="mt-2">
                {this.renderDetailButton(order, "Details", "btn btn-outline-secondary btn-sm")}
              </div>
            </div>
          </div>
        </li>
      );
    });

    return (
      <div>
        <div className="row">
          {isEditable && <div className="col-2 text-center">Order Source</div>}
          <div className={classNames("text-center", {
            "col-2": isEditable,
            "col-3": !isEditable,
          })}>Customer Name</div>
          {/* <div className="col-1 text-center">Order ID</div> */}
          <div className="col-3 text-center">Date</div>
          <div className="col-3 text-center">Product</div>
          <div className="col-2 text-center">Total / Action</div>
        </div>
        <ul className="list-group">{orders}</ul>
        <Popup
          position="right center"
          modal={true}
          open={this.props.popup.isMemberPopup}
          closeOnDocumentClick
          onClose={this.props.hideMemberPopup}
          contentStyle={{
            position: "fixed",
            zIndex: "1",
            height: "100%",
            width: "40vw",
            padding: "30px",
            right: "0",
            top: "0",
            overflowY: "auto"
          }}
          arrow={false}
          closeOnEscape={true}
        >
          <div className="modal-container">
            <AddMember />
          </div>
        </Popup>
        {this.state.selectedOrderDetail && (
          <Popup
            position="right center"
            modal={true}
            open={this.state.isDetailModalOpen}
            closeOnDocumentClick
            onClose={this.closeDetailModal}
            contentStyle={{
              position: "fixed",
              zIndex: "1",
              height: "100%",
              width: "40vw",
              padding: "30px",
              right: "0",
              top: "0",
              overflowY: "auto"
            }}
            arrow={false}
            closeOnEscape={true}
          >
            <div className="modal-container">
              <h2>Order Details</h2>
              <p><strong>Customer:</strong> {this.state.selectedOrderDetail.CustomerName}</p>
              <p><strong>Email:</strong> {this.state.selectedOrderDetail.Email}</p>
              <p><strong>Order ID:</strong> {this.state.selectedOrderDetail.Id}</p>
              <p><strong>Order Description:</strong> {this.state.selectedOrderDetail.OrderDescription}</p>
              <p>
                <strong>Product:</strong>{" "}
                {this.state.selectedOrderDetail.productMatch
                  ? this.state.selectedOrderDetail.ProductName
                  : "No product match"}
              </p>
              <p><strong>Product Type:</strong> {this.getProductTypeLabel(this.state.selectedOrderDetail.purchaseType)}</p>
              <p><strong>Stripe Product/Price ID:</strong> {this.state.selectedOrderDetail.stripePriceId}</p>
              {this.getOrderReason(this.state.selectedOrderDetail) && (
                <p><strong>Reason:</strong> {this.getOrderReason(this.state.selectedOrderDetail)}</p>
              )}
              <hr />
              {!this.state.selectedOrderDetail.userMatch && (
                <div>
                  <p className="text-danger">No user match found for this order.</p>
                  {isEditable && this.state.selectedOrderDetail && this.state.selectedOrderDetail.source === "Stripe" && (
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      onClick={() => {
                        this.closeDetailModal();
                        this.props.showMemberPopup();
                      }}
                    >
                      Add member
                    </button>
                  )}
                </div>
              )}
              {this.state.selectedOrderDetail.userMatch && !this.state.selectedOrderDetail.productMatch && (
                <p className="text-warning">This order could not be linked to a known product.</p>
              )}
              <div className="mt-4">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => this.handleDeleteOrder(this.state.selectedOrderDetail)}
                >
                  Delete Order
                </button>
              </div>
            </div>
          </Popup>
        )}
        {this.state.selectedOrder && (
          <Popup
            position="right center"
            modal={true}
            open={this.state.isCourseModalOpen}
            closeOnDocumentClick
            onClose={this.closeCourseModal}
            contentStyle={{
              position: "fixed",
              zIndex: "1",
              height: "100%",
              width: "40vw",
              padding: "30px",
              right: "0",
              top: "0",
              overflowY: "auto"
            }}
            arrow={false}
            closeOnEscape={true}
          >
            <div className="modal-container">
              <h2>{this.state.selectedOrder.CustomerName}</h2>
              {this.props.members.member &&
              this.props.members.member._id === this.state.selectedOrder.UserId ? (
                <Subscriptions
                  userID={this.props.members.member._id}
                  courses={this.props.members.member.courses || []}
                  pas={this.props.members.member.pas || {}}
                  subscriptions={this.props.members.member.subscriptions || []}
                />
              ) : (
                <div>Loading...</div>
              )}
            </div>
          </Popup>
        )}
      </div>
    );
  }
}

OrderList.propTypes = {
  orders: PropTypes.array.isRequired,
  latestSyncOrderIds: PropTypes.array
};
const mapStateToProps = state => ({
  auth: state.auth,
  members: state.members,
  popup: state.popup
})
export default connect(
  mapStateToProps,
  { getUser, showMemberPopup, hideMemberPopup, deleteStripeOrder }
)(OrderList);
